function initContact() {
	// Disabled le bouton "Envoyer" si la checkbox n'est pas cochée
	$( ".form-contact input[type=submit]" ).prop( "disabled", true ); //Disable
	var arrow = $("<a href='#' class='btn btn--form'><span><img class=\"arrow-btn\" src=\"/wp-content/themes/cis-scolaire/images/arrow-btn.png\" alt=\"Voir\"/></span></a>");

	$('input[name=acceptance]').change(function(){
		if($(this).is(':checked')) {
			$( "input[type=submit]" ).prop( "disabled", false ); //Enable
			$( ".form-field--submit" ).removeClass("disabled");
			$('.form-field--submit').append(arrow);
		} else {
			$( "input[type=submit]" ).prop( "disabled", true ); //Disable
			$( ".form-field--submit" ).addClass("disabled");
			arrow.detach();
		}
	});

	var contactFormInputs = $('.form-contact input, .form-contact textarea');
	contactFormInputs.on('focus',function() {
		$('.form-contact label').removeClass('active');
		$(this).closest('.form-field').find('label').addClass('active');

		if ($(this).hasClass('wpcf7-not-valid')) {
			$(this).removeClass('wpcf7-not-valid');
			$(this).siblings('span').remove();
		}
	});

	contactFormInputs.on('blur',function(){
		$('.form-contact label').removeClass('active');
		if($(this).val().length){
			$(this).closest('.form-field').find('label').addClass('filled');
		}else{
			$(this).closest('.form-field').find('label').removeClass('filled');
		}
	});
}